import React, { Component } from "react";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { valHooks } from "jquery";
import moment from "moment";
import { adToBS } from "nepali-calander";
import { compareByYearLevelName } from "../../utils/Utils";

class ListStudentAttendanceDetails extends Component {
  state = {
    attendanceRecord: [],
    schoolInfos: null,
  };

  getStudeentName = () => {
    //fint the name of the std. whose attendance details is being downloaded
  };
  setTableHeader = (data) => {
    let endOfMonth = this.props.selectedMonth;
    return data ? (
      <>
        <tr>
          <th
            style={{ textAlign: "center" }}
            colSpan={endOfMonth.daysInMonth + 2}
          >
            Days
          </th>
        </tr>
        <tr>
          <th></th>
          {Array.from({ length: endOfMonth.daysInMonth }, (_, i) => (
            <th key={i}>{i + 1}</th>
          ))}
          {/* {data.map((item, id) => {
          return (<th>{new Date(item.date).getDate()}</th>)
        })} */}
          <th>Total Present</th>
        </tr>
      </>
    ) : (
      ""
    );
  };

  renderAttendanceStatus = (key) => {
    let totalPresentDay = 0;
    this.props.studentAttendanceRecord[key].map((item) => {
      if (item.isPresent) totalPresentDay++;
    });
    let endOfMonth = this.props.selectedMonth;
    let calendarMode = localStorage.getItem("calendar-mode") || "ad";
    return (
      <>
        {Array.from({ length: endOfMonth.daysInMonth }, (_, i) => {
          let record = this.props.studentAttendanceRecord[key].find(
            (item, id) =>
              calendarMode == "bs"
                ? adToBS(item.date).bs_d == i + 1
                : new Date(item.date).getDate() == i + 1,
          );
          return record ? (
            <td>
              {record.isPresent ? (
                <FontAwesomeIcon icon={faCheckCircle} color="#1abc9c" />
              ) : (
                <FontAwesomeIcon icon={faTimesCircle} color="#a70707" />
              )}
            </td>
          ) : (
            <td>-</td>
          );
        })}
        <td>{totalPresentDay}</td>
      </>
    );
  };

  handleExportToPDF = async () => {
    document.getElementById("printAttendance").parentNode.style.overflow =
      "visible";
    const table = document.getElementById("arr-table");
    table.parentNode.style.overflowX = "visible";
    table.parentNode.style.width = "fit-content";

    const element = document.getElementById("printAttendance");
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "landscape",
      format: "a4",
      unit: "mm",
    });

    const imgProperties = pdf.getImageProperties(data);

    const margin = 10;

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const contentWidth = pageWidth - margin * 2;
    const contentHeight =
      (imgProperties.height * contentWidth) / imgProperties.width;

    pdf.addImage(data, "PNG", margin, margin, contentWidth, contentHeight);
    pdf.save("AttendanceDetails.pdf");

    table.parentNode.style.overflowX = "auto";
    table.parentNode.style.width = "100%";
  };

  getSchoolInfo = () => {
    axiosPost(URL.getSchoolByKey, {}, (response) => {
      if (response.status === 200) {
        this.setState({
          schoolInfos: response.data.data,
        });
      }
    });
  };

  componentDidMount() {
    this.getSchoolInfo();
  }

  render() {
    return (
      <>
        <div>
          <div id="printAttendance">
            {Object.keys(this.props.studentAttendanceRecord).length > 0 && (
              <>
                <div className="container-fluid row calendar-print-header my-3">
                  <div className="col-md-12 text-center">
                    <h2>{this.state.schoolInfos?.name}</h2>
                    <h5>{this.state.schoolInfos?.address}</h5>
                    <h6>{this.state.currentAcYrName}</h6>
                    {this.props.classrooms
                      ? this.props.classrooms
                          .filter(
                            (classroom) =>
                              classroom?.id ===
                                parseInt(this.props?.classRoomName[0]) &&
                              classroom?.yearLevelId ===
                                parseInt(this.props?.classRoomName[1]),
                          )
                          .map(
                            (classroom, idx) =>
                              `Class ${classroom.yearLevelName} - ${classroom.name}`,
                          )
                      : null}
                  </div>
                </div>

                <div className="py-2">
                  <b>Month: </b>
                  {console.log(this.props.selectedMonth)}
                  {this.props.selectedMonth?.month} -{" "}
                  {this.props.selectedMonth?.year}
                </div>
              </>
            )}

            {Object.keys(this.props.studentAttendanceRecord).length > 0 && (
              <div id="arr-table" className="arr-table-container">
                <table className="arr-table">
                  <thead>
                    {this.setTableHeader(
                      Object.values(this.props.studentAttendanceRecord)[0],
                    )}
                  </thead>
                  <tbody>
                    {Object.keys(this.props.studentAttendanceRecord).length >
                    0 ? (
                      <>
                        {Object.keys(this.props.studentAttendanceRecord).map(
                          (key, id) => {
                            return (
                              <tr>
                                <td>{key}</td>
                                {this.renderAttendanceStatus(key)}
                              </tr>
                            );
                          },
                        )}
                      </>
                    ) : null}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="text-right">
            <button
              className="tt-button tt-button-primary my-2"
              onClick={() => this.handleExportToPDF()}
              style={{
                display: this.props.showBtn ? " block" : "none",
              }}
            >
              Export as PDF
            </button>
          </div>
        </div>
      </>
    );
  }
}
export default ListStudentAttendanceDetails;
